
class CartUpdater {
    constructor(cartLineItems, cartAction, membership = null, callback = null) {
        this.cartLineItems = cartLineItems;
        this.cartAction = cartAction;
        this.membership = membership;
        this.callback = callback;
        this.freeInstallsRemaining = 0;
        this.freeInstallId = null;
        this.cartTotalBenefitValue = 0;
        this.lineItemIndex = 0;
        this.membershipBenefits = null;
        this.membershipBenefitsDict = {
            PRODUCTS: [],
            SERVICES: [],
            PRODUCTS_AND_SERVICES: [],
            MEMBERSHIPS: [],
            REMOTE_TECH_SUPPORT: [],
        };

        // Check for any membership in cart.
        this.isMembershipInCart = this.checkForMembershipInCart();

        // OssMembership: Check for membership in cart with tag Membership.Tags.APPLY_FREE_INSTALL
        this.isOssMembershipInCart = this.checkForMembershipAutoApplyTagItemsInCart();

        this.setFreeInstallsRemaining();

        this.group1NoFreeInstall = this.checkForGroup1WithNoFreeInstall();

        this.hasOnlyOneService = this.isOnlyService();

        if (!this.isMembershipActiveCheck()) {
            this.cartAction = Cart.REMOVE_MEMBERSHIP_BENEFITS;
        }
    }

    // *** tagsToArray ***
    tagsToArray(tagsString, source) {
        if (!isEmpty(tagsString) && !Array.isArray(tagsString)) {
            tagsString = tagsString.split(",");
        }

        if (!isEmpty(tagsString) && Array.isArray(tagsString)) {
            return tagsString.map(function (tag) {
                return tag.trim();
            });
        } else {
            let errMsg = `ERROR in tagsToArray: missing product tags.<br/>Source = "${source}"`;
            //window.showToast(errMsg, "error");
            ontech.log.error(`!!! ${errMsg} !!!`);
            //throw errMsg;
        }
    }

    isOnlyService() {
        let listOfServiceIds, serviceCount;
        serviceCount = 0;
        listOfServiceIds = [];
        if (!isEmpty(this.cartLineItems)) {
            for (const cartLineItem of this.cartLineItems) {
                if (!isEmpty(cartLineItem.lineItem) && isCartItemService(cartLineItem.lineItem)) {
                    if (!listOfServiceIds.includes(cartLineItem.lineItem.id)) {
                        serviceCount++;
                        listOfServiceIds.push(cartLineItem.lineItem.id);
                    }
                }
            }
        }
        if (serviceCount === 1) {
            return  true;
        }

        return false;
    }
    
    checkForGroup1WithNoFreeInstall() {
        if (!isEmpty(this.cartLineItems)) {
            for (const cartLineItem of this.cartLineItems) {
                if (
                    cartLineItem.lineItem
                    && cartLineItem.properties
                    && cartLineItem.properties[Cart.Properties.PRODUCT_TAGS]
                ) {
                    const tagsArray =
                        this.tagsToArray(
                            cartLineItem.properties[Cart.Properties.PRODUCT_TAGS],
                            "checkForGroup1WithNoFreeInstall");
                    if (tagsArray.includes("group-1") && !tagsArray.includes(Membership.Tags.FREE_INSTALL)) {
                        return true;
                    }
                }
            }
        }
        // ontech.log.debug(`$$$ checkForMembershipInCart = ${retVal} $$$`, this.cartLineItems);
        return false;
    }

    checkForMembershipInCart() {
        // evaluate the cart and return TRUE if there is an item in the cart with the product_type ProductTypes.MEMBERSHIP
        return ontech.isMembershipInCart(this.cartLineItems);
    }

    checkForMembershipAutoApplyTagItemsInCart() {
        // OssMembership: evaluate the cart and return TRUE if there is an item in the cart with the tag Membership.Tags.APPLY_FREE_INSTALL
        if (!isEmpty(this.cartLineItems)) {
            for (const cartLineItem of this.cartLineItems) {
                if (
                    cartLineItem.properties
                    && cartLineItem.properties[Cart.Properties.PRODUCT_TAGS]
                ) {
                    const tagsArray =
                        this.tagsToArray(
                            cartLineItem.properties[Cart.Properties.PRODUCT_TAGS],
                            "checkForMembershipAutoApplyTagItemsInCart");
                    if (tagsArray.includesIgnoreCase(Membership.Tags.APPLY_FREE_INSTALL)) {
                        return true;
                    }
                } 
            }
        }

        //ontech.log.debug(`$$$ checkForMembershipAutoApplyItemsInCart = false $$$`, this.cartLineItems);
        return false;
    }

    isMembershipActiveCheck() {
        return (
            (!isUndefinedOrNull(this.membership) && !isEmpty(this.membership.membershipPlanSku))
            || this.isMembershipInCart
        );
    }

    setFreeInstallsRemaining() {
        // ToDo: is checking for membershipPlanSku correct?
        if (!isEmpty(this.membership) && !isEmpty(this.membership.membershipPlanSku)) {
            if (
                this.isMembershipInCart
                && (this.membership.numFreeInstallsRemaining + this.membership.numFreeInstallsRedeemed) < 2
            ) {
                this.freeInstallsRemaining = this.membership.numFreeInstallsRemaining + 1;
            }
            else {
                this.freeInstallsRemaining = this.membership.numFreeInstallsRemaining;
            }

            this.freeInstallId = null;
        } else if (this.isMembershipInCart && !this.isOssMembershipInCart) {
            // if not a member, but a non-OSS membership SKU is in the cart
            this.freeInstallsRemaining = 1;
            this.freeInstallId = null;
        
        } 
        else if (this.isOssMembershipInCart) {
            // if not a member, but an OSS membership SKU is in the cart
            this.freeInstallsRemaining = 0;
        }
    }

    // ToDo: Is this used?
    getMembershipBenefit(benefitType) {
        let benefits = [];
        if (benefitType in this.membershipBenefitsDict) {
            benefits = this.membershipBenefitsDict[benefitType];
        }

        return benefits;
    }

    async updateCart() {
        //customLog(`CartUpdater->updateCart`, 'info');
        this.membershipBenefits = this.getMembershipBenefits();

        // Organize membership benefits in a dictionary by benefitAppliesTo
        for (const benefit of this.membershipBenefits.benefits) {
            if (benefit.benefitAppliesTo in this.membershipBenefitsDict) {
                this.membershipBenefitsDict[benefit.benefitAppliesTo].push(benefit);
            } else {
                ontech.log.error(
                    `Member benefitAppliesTo ${benefit.benefitAppliesTo} was not expected.`
                );
            }
        }

        //ontech.log.debug(JSON.stringify(this.cartLineItems, null, 2));
        await this.updateCartLineItem();
    }

    compareProperties(obj, source) {
        return Object.keys(source).every(
            (key) => obj.hasOwnProperty(key) && obj[key] === source[key]
        );
    }

    // This updates the properties of each line item in the cart. It is called
    // recursively so the POSTs will happen sequentially instead of all at once.
    async updateCartLineItem() {
        //customLog(`CartUpdater->updateCartLineItem #${this.lineItemIndex}`, 'info');

        // Stop the recursion when we're out of line items to process
        if (this.lineItemIndex < this.cartLineItems.length) {
            //cartDebug(`     Processing item #${this.lineItemIndex}`);

            // Get the new properties for this line item based on the cartAction and membershipSku
            let lineItem = this.cartLineItems[this.lineItemIndex++];
            lineItem.properties = selfOrDefault(lineItem.properties, {});
            let newProperties = this.getNewProperties(lineItem);

            // enableCartDebug is set in theme.liquid and checkout.liquid
            if (window.enableCartDebug) {
                // ontech.log.debug('lineItem.properties', lineItem.properties);
                // ontech.log.debug('newProperties.properties', newProperties.properties);
            }

            // Don't POST update if the properties haven't changed
            let isMatch = this.compareProperties(
                lineItem.properties,
                newProperties.properties
            );

            //cartDebug(`isMatch = ${isMatch}, properties are different, do update for #${this.lineItemIndex}`);
            if (!isMatch) {
                // Update the line item on Shopify
                // customLog(`API Call - /change.json: updating cart line item with new properties`, 'debug');

                ontech.setCartModified();
                await changeCart(newProperties)
                    .catch(error => {
                        ontech.log.error("Error updating cart line item", error);
                    });

                //ontech.log.info(`Update the next line item`, cart);
                await this.updateCartLineItem();
            } else {
                await this.updateCartLineItem();                
                // customLog(`Properties aren't changed for line item ${this.lineItemIndex}, skipping update`, 'info');
            }
        } else {
            //customLog(`Done updating all line items. Call updateCarAttributes()`, 'info');
            await this.callCallback();
        }
    }

    async callCallback() {
        if (!isUndefinedOrNull(this.callback)) {
            this.callback(true);
        }
    }

    calculateBenefitValue(benefitType, price, benefitAmount, quantity) {
        let itemItemTotalBenefitValue = 0;

        switch (benefitType) {
            case Membership.DiscountTypes.PERCENT_OFF:
                itemItemTotalBenefitValue =
                    Math.round(
                        (quantity * (price / 100.0) * benefitAmount +
                            Number.EPSILON) *
                        100
                    ) / 100;
                break;
            case Membership.DiscountTypes.FIXED_PRICE:
                // todo: implement
                break;
            case Membership.DiscountTypes.FREE_INSTALLATION:
                itemItemTotalBenefitValue = quantity * price;
                break;
            case Membership.DiscountTypes.FREE_ITEM:
                // todo: implement
                break;
        }

        this.cartTotalBenefitValue += itemItemTotalBenefitValue;
        return itemItemTotalBenefitValue;
    }

    getMembershipBenefitProperties(cartLineItem) {
        // Any properties here will be added in addition to any properties added below
        let memberBenefitProperties = {};
        cartLineItem.lineItem.properties = selfOrDefault(cartLineItem.lineItem.properties,{});

        let isBundleItem = toBoolean(cartLineItem.lineItem.properties[Cart.Properties.IS_BUNDLE]);

        // ontech.log.debug(`# cartLineItem.key: ${cartLineItem.key}`);
        // ontech.log.debug(`# cartLineItem.line: ${cartLineItem.line}`);
        // ontech.log.debug(`# cartLineItem.lineItem.product_type: ${cartLineItem.lineItem.product_type}`);
        // ontech.log.debug(`# cartLineItem.lineItem.properties[CART.PROPERTIES.IS_BUNDLE]: ${cartLineItem.lineItem.properties[CART.PROPERTIES.IS_BUNDLE]}`);
        // ontech.log.debug(`# isBundleItem: ${isBundleItem ? "yes" : "no"}`);

        // return here if membership is disabled
        if (!ontech.state.get(State.Membership.IS_ENABLED)) {
            return memberBenefitProperties;
        }

        // Bundle items never have membership benefits applied
        if (isBundleItem) {
            //ontech.log.info(`# Skipping bundle item...`);
            return memberBenefitProperties;
        }

        // Memberships never have membership benefits applied
        if (isCartItemMembership(cartLineItem.lineItem)) {
            //ontech.log.debug(`# Adding _membership_sku=true attribute to membership`);
            // ontech.log.debug("$$$ cartLineItem $$$", cartLineItem);

            return {
                ...memberBenefitProperties,
                '_membership_sku': true
            };
        }

        //Exclude from membership benefits and return
        if (cartLineItem.properties[Cart.Properties.PRODUCT_TAGS]
            && this.tagsToArray(
                cartLineItem.properties[Cart.Properties.PRODUCT_TAGS],
                "getMembershipBenefitProperties #1")
                .includes(Membership.Tags.EXCLUDE_FROM_BENEFITS)) {
            return memberBenefitProperties;
        }

        if (cartLineItem.properties[Cart.Properties.IS_GIFT]) {
            let itemItemTotalBenefitValue =
                Math.round(
                    cartLineItem.lineItem.quantity *
                        (cartLineItem.lineItem.price / 100.0) *
                        100
                ) / 100;
            this.cartTotalBenefitValue += itemItemTotalBenefitValue;
            return memberBenefitProperties;
        }

        switch (cartLineItem.lineItem.product_type) {
            case ProductTypes.PRODUCT:
                //customLog(`# Applying member benefits for "Product" product type`, 'info');

                for (const benefit of this.membershipBenefitsDict.PRODUCTS) {
                    //ontech.log.debug("Applied product benefit: ", benefit);

                    // Don't have one of these benefits in the current SKU
                    // What is the mapping of Benefit Applies To to Benefit Types?
                    if (benefit.benefitType === Membership.DiscountTypes.PERCENT_OFF) {
                        // todo: Create a generic apply Membership.DiscountTypes.PERCENT_OFF, etc., method?
                    }
                }

                for (const benefit of this.membershipBenefitsDict.PRODUCTS_AND_SERVICES) {
                    //ontech.log.debug("## apply product benefit: ", benefit);

                    if (benefit.benefitType === Membership.DiscountTypes.PERCENT_OFF) {
                        memberBenefitProperties = {
                            ...memberBenefitProperties,
                            '_cartLineItemIndex': cartLineItem.line, // for testing only
                            // 'MembershipBenefitCode': benefit.benefitCode,
                            '_membership_action': "membership properties added",
                            '_benefit_code': benefit.benefitCode,
                            '_benefit_type': benefit.benefitType,
                            '_benefit_applies_to': benefit.benefitAppliesTo,
                            '_benefit_amount': benefit.benefitAmount,
                            '_benefit_quantity_used': cartLineItem.lineItem.quantity,
                            '_benefit_value': this.calculateBenefitValue(
                                benefit.benefitType,
                                cartLineItem.lineItem.price,
                                benefit.benefitAmount,
                                cartLineItem.lineItem.quantity
                            ),
                        };
                    }
                }
                break;

            case ProductTypes.SERVICE:
                //customLog(`# Applying member benefits for "Service" product type`, 'info');
                let benefitApplied = false;
                for (const benefit of this.membershipBenefitsDict.SERVICES) {
                    let isDiscounted = false;
                    for (const discount of cartLineItem.lineItem.discounts) {
                        if (discount.title === Membership.DiscountTitles.MULTIPLE_SERVICE_DISCOUNT) {
                            isDiscounted = true;
                            break;
                        }
                    }

                    if (benefit.benefitType === Membership.DiscountTypes.FREE_INSTALLATION
                        && (
                            this.freeInstallsRemaining > 0
                            || this.freeInstallId === cartLineItem.lineItem.id
                        )
                        && cartLineItem.properties[Cart.Properties.PRODUCT_TAGS]
                        && this.tagsToArray(
                            cartLineItem.properties[Cart.Properties.PRODUCT_TAGS],
                            "getMembershipBenefitProperties #2")
                            .includes(Membership.Tags.FREE_INSTALL)
                        && (
                            (!isDiscounted || this.hasOnlyOneService)
                            || this.group1NoFreeInstall
                            || toBoolean(cartLineItem.properties[Cart.Properties.ON_SITE_SALES])
                        )
                    ) {
                        if (this.freeInstallsRemaining > 0) {
                            --this.freeInstallsRemaining;
                            this.freeInstallId = cartLineItem.lineItem.id;
                        }

                        benefitApplied = true;
                        memberBenefitProperties = {
                            ...memberBenefitProperties,
                            '_cartLineItemIndex': cartLineItem.line, // for testing only
                            // 'MembershipBenefitCode': benefit.benefitCode,
                            '_membership_action': "membership properties added",
                            '_benefit_code': benefit.benefitCode,
                            '_benefit_type': benefit.benefitType,
                            '_benefit_applies_to': benefit.benefitAppliesTo,
                            '_benefit_amount': benefit.benefitAmount,
                            '_benefit_quantity_used': cartLineItem.lineItem.quantity,
                            '_benefit_value': this.calculateBenefitValue(
                                benefit.benefitType,
                                99.99,
                                1,
                                cartLineItem.lineItem.quantity
                            ),
                        };
                    }

                    if (
                        (benefit.benefitType === Membership.DiscountTypes.PERCENT_OFF)
                        && cartLineItem.properties[Cart.Properties.PRODUCT_TAGS]
                        && this.tagsToArray(
                            cartLineItem.properties[Cart.Properties.PRODUCT_TAGS],
                            "getMembershipBenefitProperties #3")
                            .includes(Membership.Tags.MEMBER_20_PERCENT_OFF_ADVANCE_INSTALL)
                    ) {
                        benefitApplied = true;
                        memberBenefitProperties = {
                            ...memberBenefitProperties,
                            '_cartLineItemIndex': cartLineItem.line, // for testing only
                            // 'MembershipBenefitCode': benefit.benefitCode,
                            '_membership_action': "membership properties added",
                            '_benefit_code': benefit.benefitCode,
                            '_benefit_type': benefit.benefitType,
                            '_benefit_applies_to': benefit.benefitAppliesTo,
                            '_benefit_amount': benefit.benefitAmount,
                            '_benefit_quantity_used': cartLineItem.lineItem.quantity,
                            '_benefit_value': this.calculateBenefitValue(
                                benefit.benefitType,
                                (cartLineItem.lineItem.price / 100.0),
                                1,
                                cartLineItem.lineItem.quantity
                            ),
                        };
                    }                    
                }

                if (!benefitApplied) {
                    for (const benefit of this.membershipBenefitsDict.PRODUCTS_AND_SERVICES) {
                        //ontech.log.debug("## apply benefit: ", benefit);

                        if (benefit.benefitType === Membership.DiscountTypes.PERCENT_OFF) {
                            memberBenefitProperties = {
                                ...memberBenefitProperties,
                                '_cartLineItemIndex': cartLineItem.line, // for testing only
                                // 'MembershipBenefitCode': benefit.benefitCode,
                                '_membership_action': "membership properties added",
                                '_benefit_code': benefit.benefitCode,
                                '_benefit_type': benefit.benefitType,
                                '_benefit_applies_to': benefit.benefitAppliesTo,
                                '_benefit_amount': benefit.benefitAmount,
                                '_benefit_quantity_used': cartLineItem.lineItem.quantity,
                                '_benefit_value': this.calculateBenefitValue(
                                    benefit.benefitType,
                                    cartLineItem.lineItem.price,
                                    benefit.benefitAmount,
                                    cartLineItem.lineItem.quantity
                                ),
                            };
                        }
                    }
                }

                break;

            case ProductTypes.REMOTE_TECH_SUPPORT:
                //customLog(`Applying member benefits for "RemoteTechSupport" product type`, 'info');
                // todo: implement this product type
                //this.membershipBenefitsDict.REMOTE_TECH_SUPPORT
                break;

            default:
                ontech.log.error(
                    `Member benefit for ${cartLineItem.lineItem.product_type} not found.`
                );
                break;
        }

        return memberBenefitProperties;
    }

    getNewProperties(cartLineItem) {
        //id: cartLineItem.key,
        //line: cartLineItem.line,

        let retVal = {
            id: cartLineItem.key,
            quantity: cartLineItem.lineItem.quantity,
        };

        if (this.cartAction === Cart.UPDATE_MEMBERSHIP_BENEFITS) {
            const membershipBenefits = this.getMembershipBenefitProperties(cartLineItem);

            //ontech.log.debug(`*** Line: ${this.lineItemIndex}`)
            //ontech.log.debug(`*** Key: ${cartLineItem.key}`)

            retVal.properties = {
                ...cartLineItem.properties,
                ...membershipBenefits,
            };
        } else if (this.cartAction === Cart.REMOVE_MEMBERSHIP_BENEFITS) {
            let {
                MembershipBenefitCode,
                _benefit_code,
                _benefit_type,
                _benefit_applies_to,
                _benefit_amount,
                _benefit_value,
                ...newProperties
            } = cartLineItem.properties;

            // IMPORTANT: In order for Change Cart API to remove line item properties, you can't just send a properties object
            // with nothing in it. You need a new property, then the other ones will be removed.
            newProperties._membership_action = "n/a";

            retVal.properties = newProperties;
        } else {
            retVal.properties = cartLineItem.properties;
        }

        return retVal;
    }

    // Gets the membership benefits associated with the user's membership plan
    getMembershipBenefits() {
        // ToDo: Call service with this.membership.membershipPlanSku

        const membershipSkuJson = `{
      "id": 1,
      "sku": "1780",
      "title": "OnTech+",
      "description": "OnTech+",
      "shopifyVariantId": "41051467645121",
      "planDuration": "1Y",
      "active": true,
      "availableStartDate": "2020-03-26",
      "availableEndDate": "2021-12-31",
      "benefits": [
          {
              "id": 1,
              "benefitCode": "1_FREE_INSTALLATION",
              "title": "1 Free Installation",
              "description": "1 Free Installation",
              "benefitType": "FREE_INSTALLATION",
              "quantity": 1,
              "benefitAmount": 0,
              "benefitAppliesTo": "SERVICES",
              "active": true
          },
          {
              "id": 2,
              "benefitCode": "10_PERCENT_OFF_PRODUCTS_AND_SERVICES",
              "title": "10% Off Products and Services",
              "description": "10% Off Products and Services",
              "benefitType": "PERCENT_OFF",
              "quantity": -1,
              "benefitAmount": 0.1,
              "benefitAppliesTo": "PRODUCTS_AND_SERVICES",
              "active": true
          },
          {
              "id": 3,
              "benefitCode": "1_YEAR_REMOTE_TECH_SUPPORT",
              "title": "1 Year Remote Tech Support",
              "description": "1 Year Remote Tech Support",
              "benefitType": "FREE_ITEM",
              "quantity": -1,
              "benefitAmount": 49.99,
              "benefitAppliesTo": "REMOTE_TECH_SUPPORT",
              "active": true
          },
          {
              "id": 4,
              "benefitCode": "20_PERCENT_OFF_SELECT_ITEMS",
              "title": "20% Percent Off Select Items",
              "description": "20% Percent Off Select Items",
              "benefitType": "PERCENT_OFF",
              "quantity": -1,
              "benefitAmount": 0.2,
              "benefitAppliesTo": "SERVICES",
              "active": true
          }
       ]
    }`;

        return JSON.parse(membershipSkuJson);
    }
}
